import { publishIsOtpSent } from './PublishStore';

export const updatePublishIsOtpSent = (value) => publishIsOtpSent.update((oldValue) => value);
